var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9999 2.39999C8.21208 2.39999 8.41556 2.48428 8.56559 2.63431C8.71562 2.78434 8.7999 2.98782 8.7999 3.19999V7.19999H12.7999C13.0121 7.19999 13.2156 7.28428 13.3656 7.43431C13.5156 7.58434 13.5999 7.78782 13.5999 7.99999C13.5999 8.21217 13.5156 8.41565 13.3656 8.56568C13.2156 8.71571 13.0121 8.79999 12.7999 8.79999H8.7999V12.8C8.7999 13.0122 8.71562 13.2157 8.56559 13.3657C8.41556 13.5157 8.21208 13.6 7.9999 13.6C7.78773 13.6 7.58425 13.5157 7.43422 13.3657C7.28419 13.2157 7.1999 13.0122 7.1999 12.8V8.79999H3.1999C2.98773 8.79999 2.78425 8.71571 2.63422 8.56568C2.48419 8.41565 2.3999 8.21217 2.3999 7.99999C2.3999 7.78782 2.48419 7.58434 2.63422 7.43431C2.78425 7.28428 2.98773 7.19999 3.1999 7.19999H7.1999V3.19999C7.1999 2.98782 7.28419 2.78434 7.43422 2.63431C7.58425 2.48428 7.78773 2.39999 7.9999 2.39999Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/Plus.9956f0e009b78458d643dbab5511eea6.svg";
export { ForwardRef as ReactComponent };